import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import {
   getUserCourseAssignments,
   GetUserCourseAssignmentsOptions,
   UserCourseAssignment,
} from '~/monolith-api';

export type { GetUserCourseAssignmentsOptions, UserCourseAssignment };

const getUserCourseAssignmentsSchema = z.object({
   userid: z.number(),
   page: z.number().optional(),
   pageSize: z.number().optional(),
});

export default createBFFHandlers({
   post: async (req, res) => {
      const { userid, page, pageSize } = getUserCourseAssignmentsSchema.parse(req.body);
      const monolithClient = getServerSideMonolithClient(req);
      const result = await getUserCourseAssignments(userid, {
         page: page,
         pageSize: pageSize,
         apiClient: monolithClient,
      });
      res.status(200).json(result);
   },
});

export const getUserCourseAssignmentsFromClient = (
   userid: number,
   { page, pageSize }: GetUserCourseAssignmentsOptions
): ReturnType<typeof getUserCourseAssignments> => {
   return bff()
      .post('/courses/assignments/user/getUserCourseAssignments', {
         userid,
         page,
         pageSize,
      })
      .then(response => response.data);
};
